import LayoutSetLevelZero from 'components/ui/layout-set/general/layout-set-level-zero';
import PageInvitationsList from 'components/pages/professional/persons/invitations/list/page-invitations-list';

import ButtonSendInvitation from 'components/pages/professional/persons/invitations/shared/blocks/cmpt-button-send-invitation';

import PageSendInvite from 'components/pages/professional/persons/invitations/send-invite/page-send-invite';
import PageInviteDetails from 'components/pages/professional/persons/invitations/details/page-invite-details';

import { INVITATION_TYPE } from 'constants/values';

export default [
  {
    path: '/professional/persons/invitations',
    component: LayoutSetLevelZero,
    children: [
      {
        path: '',
        props: {
          default: route => ({
            page: Number(route.query.page),
            meta: {
              title: 'label.participants',
              section: 'label.persons',
              navigation: {
                index: 'invitations-list',
                edit: 'invite-details',
                cancel: 'invitations-list',
              },
            },
          }),
        },
        meta: { auth: true },
        name: 'invitations-list',
        components: {
          default: PageInvitationsList,
          collapsedMenuTop: ButtonSendInvitation,
        },
        children: [
          {
            meta: { auth: true },
            path: 'invite-participant',
            name: 'invite-participant',
            component: PageSendInvite,
            props: {
              type: INVITATION_TYPE.PARTICIPANT,
              meta: {
                title: 'label.invite_participant',
                navigation: {
                  cancel: 'invitations-list',
                  success: 'invitations-list',
                },
              },
            },
          },
          {
            path: 'invite-team-member',
            name: 'invite-team-member',
            component: PageSendInvite,
            meta: { auth: true },
            props: {
              type: INVITATION_TYPE.TEAM_MEMBER,
              meta: {
                title: 'label.invite_team_member',
                navigation: {
                  cancel: 'invitations-list',
                  success: 'invitations-list',
                },
              },
            },
          },
          {
            path: ':id(\\d+)/invite-details',
            name: 'invite-details',
            component: PageInviteDetails,
            meta: { auth: true },
            props: route => ({
              id: route.params.id,
              meta: {
                title: 'label.invite_details',
                navigation: {
                  cancel: 'invitations-list',
                  success: 'invitations-list',
                },
              },
            }),
          },
        ],
      }, // end ~ invitations-list
    ],
  }, // end ~ invitations
];



// WEBPACK FOOTER //
// ./src/router/professional/persons/router-invitations.js